module.exports = __webpack_public_path__ + "static/media/RS.9dfc6174.svg";